import { ShortAnswerDisplayComponent } from './components/short-answer-display/short-answer-display.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { ShortAnswerQuestionComponent } from './components/short-answer-question/short-answer-question.component';
import { QuestionComponent } from './components/question/question.component';
import { ResponsePieChartComponent } from './components/response-pie-chart/response-pie-chart.component';
import { EsChartComponent } from './components/es-chart/es-chart.component';
import { SafeSrcPipe } from './pipes/safe-src';
import { SafeHtmlPipe } from './pipes/safe-html';
import * as Services from './services/index';
import * as Helpers from './helpers/index';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PieChartModule } from '@swimlane/ngx-charts';
import { BarChartModule } from '@swimlane/ngx-charts';

import { TranslationModuleForChild, TranslationService } from '@examsoft/translation';
import { NgModule } from '@angular/core';


const sharedImports = [
  PieChartModule,
  BarChartModule,
  CommonModule,
  FormsModule,
  TranslationModuleForChild
];

const sharedComponents = [
  ShortAnswerDisplayComponent,
  BarChartComponent,
  PieChartComponent,
  ResponsePieChartComponent,
  ShortAnswerQuestionComponent,
  QuestionComponent,
  EsChartComponent
];

const sharedFilters = [
];

const sharedServices = [
  Services.AppSyncService,
  Services.AssetsUpdateService,
  TranslationService
];

const sharedHelpers = [
  Helpers.ChartHelper

];

const sharedPipes = [
  SafeSrcPipe,
  SafeHtmlPipe
];


@NgModule({
  declarations: [
    ...sharedComponents,
    ...sharedPipes
  ],
  imports: [
    ...sharedImports,
  ],
  exports: [
    ...sharedComponents,
    ...sharedFilters,
    TranslationModuleForChild,
    ...sharedPipes
  ],
  providers: [
    ...sharedServices,
    ...sharedHelpers
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class SharedModule {}
